// src/components/MobileNav.js
import React, { useState } from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { useAuth } from '../Context/AuthContext';
import { useAuthGate } from '../Context/AuthGateContext';
import { TbHomeBitcoin, TbFileBitcoin, TbTransactionBitcoin, TbUserBitcoin, TbMoodBitcoin } from 'react-icons/tb';
import { FiPieChart } from 'react-icons/fi';
import { MdOutlineVideogameAsset } from 'react-icons/md';
import { FiSun, FiMoon, FiLogOut, FiHelpCircle, FiVideo, FiChevronRight } from 'react-icons/fi';
import { FaReddit, FaDiscord, FaInstagram, FaFacebook } from 'react-icons/fa';
import './MobileNav.css';
import { seedGradient } from './common/Identicon';

function FaXTwitter(props) {
  return <svg viewBox="0 0 24 24" fill="currentColor" width="1em" height="1em" {...props}><path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/></svg>;
}

const NAV_ITEMS = [
  { to: '/',            icon: TbHomeBitcoin,          label: 'Market',   end: true },
  { to: '/create',      icon: TbFileBitcoin,           label: 'Crear'             },
  { to: '/my-listings', icon: TbMoodBitcoin,           label: 'Listings'          },
  { to: '/trades',      icon: TbTransactionBitcoin,    label: 'Trades'            },
  { to: '/rewards',     icon: MdOutlineVideogameAsset, label: 'Rewards'           },
];

export default function MobileNav() {
  const { user, logout } = useAuth();
  const { openAuth }     = useAuthGate();
  const navigate         = useNavigate();
  const [moreOpen, setMoreOpen] = useState(false);

  const [darkMode, setDarkMode] = useState(() => {
    const saved = localStorage.getItem('bitplify_theme');
    return saved ? saved === 'dark' : true;
  });

  const toggleDarkMode = () => {
    const next = !darkMode;
    setDarkMode(next);
    localStorage.setItem('bitplify_theme', next ? 'dark' : 'light');
    document.body.classList.toggle('dark-mode', next);
    window.dispatchEvent(new Event('storage'));
  };

  const displayName = user?.name ?? user?.username ?? 'Usuario';
  const displayRole = user?.verified ? 'Vendedor verificado' : user?.rank ?? 'Trader';
  const initials    = displayName.slice(0, 2).toUpperCase();
  const avatarColor = seedGradient(user?.walletAddress || displayName);

  const handleLogout = () => {
    setMoreOpen(false);
    logout();
    navigate('/login');
  };

  const navClass = ({ isActive }) => `mn-tab${isActive ? ' active' : ''}`;

  return (
    <>
      {/* Bottom nav bar */}
      <nav className="mobile-nav">
        {NAV_ITEMS.map(({ to, icon: Icon, label, end }) => (
          <NavLink key={to} to={to} end={end} className={navClass} onClick={(e) => {
            if (!user && to !== '/') { e.preventDefault(); openAuth('register'); }
          }}>
            <Icon className="mn-icon" />
            <span className="mn-label">{label}</span>
          </NavLink>
        ))}

        <button
          className={`mn-tab mn-more${moreOpen ? ' active' : ''}`}
          onClick={() => setMoreOpen(p => !p)}
        >
          <div className="mn-avatar-mini" style={{ background: user?.avatar ? 'transparent' : avatarColor }}>
            {user?.avatar
              ? <img src={user.avatar} alt="av" style={{ width: '100%', height: '100%', objectFit: 'cover', borderRadius: '50%' }} />
              : initials
            }
          </div>
          <span className="mn-label">Más</span>
        </button>
      </nav>

      {/* Drawer */}
      {moreOpen && (
        <div className="mn-drawer-overlay" onClick={() => setMoreOpen(false)}>
          <div className="mn-drawer" onClick={e => e.stopPropagation()}>

            <div className="mn-drawer-handle" />

            {/* Profile (logueado) o CTA de invitado */}
            {user ? (
              <div className="mn-profile" onClick={() => { setMoreOpen(false); navigate('/profile'); }}>
                <div className="mn-profile-avatar" style={{ background: user?.avatar ? 'transparent' : avatarColor }}>
                  {user?.avatar
                    ? <img src={user.avatar} alt="avatar" style={{ width: '100%', height: '100%', objectFit: 'cover', borderRadius: '50%' }} />
                    : initials
                  }
                </div>
                <div className="mn-profile-info">
                  <strong>{displayName}</strong>
                  <span>{displayRole}</span>
                </div>
                <FiChevronRight className="mn-profile-arrow" />
              </div>
            ) : (
              <div className="mn-guest">
                <div className="mn-guest-info">
                  <strong>Invitado</strong>
                  <span>Entra o crea tu cuenta para operar</span>
                </div>
                <div className="mn-guest-btns">
                  <button className="mn-guest-btn solid" onClick={() => { setMoreOpen(false); openAuth('register'); }}>Registrarse</button>
                  <button className="mn-guest-btn ghost" onClick={() => { setMoreOpen(false); openAuth('login'); }}>Entrar</button>
                </div>
              </div>
            )}

            <div className="mn-divider" />

            {/* Nav grid */}
            <div className="mn-drawer-grid">
              {[
                { to: '/',            icon: TbHomeBitcoin,          label: 'Marketplace',  end: true },
                { to: '/create',      icon: TbFileBitcoin,           label: 'Crear oferta'           },
                { to: '/my-listings', icon: TbMoodBitcoin,           label: 'My Listings'            },
                { to: '/trades',      icon: TbTransactionBitcoin,    label: 'My Trades'              },
                { to: '/portfolio',   icon: FiPieChart,              label: 'Portafolio'             },
                { to: '/profile',     icon: TbUserBitcoin,           label: 'Mi perfil'              },
                { to: '/rewards',     icon: MdOutlineVideogameAsset, label: 'Game Rewards'           },
              ].map(({ to, icon: Icon, label, end }) => (
                <NavLink
                  key={to} to={to} end={end}
                  className={({ isActive }) => `mn-drawer-item${isActive ? ' active' : ''}`}
                  onClick={(e) => {
                    if (!user && to !== '/') { e.preventDefault(); openAuth('register'); }
                    setMoreOpen(false);
                  }}
                >
                  <div className="mn-drawer-icon-wrap">
                    <Icon className="mn-drawer-icon" />
                  </div>
                  <span>{label}</span>
                </NavLink>
              ))}
            </div>

            <div className="mn-divider" />

            {/* Help */}
            <div className="mn-help-title">Centro de ayuda</div>
            <div className="mn-help-row">
              <a href="https://discord.gg/Bitplify" target="_blank" rel="noopener noreferrer" className="mn-help-btn" onClick={() => setMoreOpen(false)}>
                <FaDiscord /> Discord
              </a>
              <a href="https://www.reddit.com/r/Bitplify" target="_blank" rel="noopener noreferrer" className="mn-help-btn" onClick={() => setMoreOpen(false)}>
                <FaReddit /> Reddit
              </a>
              <NavLink to="/faq" className="mn-help-btn" onClick={() => setMoreOpen(false)}>
                <FiHelpCircle /> FAQ
              </NavLink>
              <NavLink to="/videos" className="mn-help-btn" onClick={() => setMoreOpen(false)}>
                <FiVideo /> Videos
              </NavLink>
            </div>

            {/* Social */}
            <div className="mn-social-row">
              <a href="https://x.com/Bitplify" target="_blank" rel="noopener noreferrer" className="mn-social-btn xtwitter"><FaXTwitter /></a>
              <a href="https://instagram.com/Bitplify" target="_blank" rel="noopener noreferrer" className="mn-social-btn instagram"><FaInstagram /></a>
              <a href="https://facebook.com/Bitplify" target="_blank" rel="noopener noreferrer" className="mn-social-btn facebook"><FaFacebook /></a>
              <a href="https://discord.gg/Bitplify" target="_blank" rel="noopener noreferrer" className="mn-social-btn discord"><FaDiscord /></a>
            </div>

            <div className="mn-divider" />

            {/* Dark mode */}
            <button className="mn-darkmode-btn" onClick={toggleDarkMode}>
              <span className="mn-darkmode-icon">
                {darkMode ? <FiSun /> : <FiMoon />}
              </span>
              {darkMode ? 'Modo claro' : 'Modo oscuro'}
            </button>

            {/* Logout (solo con sesión) */}
            {user && (
              <>
                <div className="mn-divider" />
                <button className="mn-logout-btn" onClick={handleLogout}>
                  <FiLogOut /> Cerrar sesión
                </button>
              </>
            )}

          </div>
        </div>
      )}
    </>
  );
}
